import {
    HistoryRecord,
    AnyField, KeyMapper, MessageField,
    PropertyDiffField,
    PropertyField,
    ReadableHistoryRecord, ResourceField
} from '@/modules/_shared/audit-log/types'

function toReadableHistoryRecords (historyRecords: HistoryRecord[]): ReadableHistoryRecord[] {
    return historyRecords.map((activity) => {
        const message = toReadableForm(activity.message)
        return {
            ...activity,
            message
        }
    })
}

function isPropertyField (val: unknown): val is PropertyField {
    if (!val) {
        return false
    }
    return (val as AnyField).fieldType === 'property'
}

function isPropertyDiffField (val: unknown): val is PropertyDiffField {
    if (!val) {
        return false
    }
    return (val as AnyField).fieldType === 'property_diff'
}

function isResourceField (val: unknown): val is ResourceField {
    if (!val) {
        return false
    }
    return (val as AnyField).fieldType === 'resource'
}

function isMessageField (val: unknown): val is MessageField {
    if (!val) {
        return false
    }
    return (val as AnyField).fieldType === 'message'
}

function isAnyField (val: unknown): val is AnyField {
    if (val === null) return false
    return (val as AnyField).fieldType !== null
}

function toReadableForm (message: string): AnyField[] {
    message = JSON.parse(message)
    if (Array.isArray(message)) {
        return message.filter(isAnyField)
    }

    return []
}

function aliasForKey (key: string, record: KeyMapper, defaultAlias: string | null = null): string {
    if (record[key]) {
        return record[key]
    }
    return (defaultAlias === null) ? key : defaultAlias
}

function aliasForAction (key: string) {
    return key.replaceAll('-', ' ').replaceAll('_', ' ')
}

export function useAuditLogModule () {
    return {
        aliasForKey,
        aliasForAction,
        toReadableActivities: toReadableHistoryRecords,
        isPropertyField,
        isPropertyDiffField,
        isResourceField,
        isMessageField
    }
}
